import React, { useEffect } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import * as source from "sources/books/platonPoints";
import Form from "./form";
import List from "./list";

const PlatonPoints = (props) => {
    useEffect(() => {
        return () => props.clearParams("platon-points");
    }, []);

    const { match, location, history } = props;
    const rootUrl = `${match.path}/list`;
    const back = () => history.push(rootUrl);
    return (
        <div className="page-content">
            <Switch location={location}>
                <Route exact path={`${match.path}/`} render={() => <Redirect to={rootUrl} />} />
                <Route
                    exact
                    path={rootUrl}
                    render={() => (
                        <List
                            {...props}
                            isTable
                            transition="full"
                            title="Рамки Платон"
                            nofilter
                            createBtnText="Добавить рамку Платон"
                        />
                    )}
                />
                <Route
                    path={`${rootUrl}/:id`}
                    render={(rest) => (
                        <Form {...rest} transition="full" title="Рамка Платон" back={back} source={source} />
                    )}
                />
                <Route
                    path={`${match.path}/new`}
                    render={() => (
                        <Form {...props} transition="full" title="Добавить рамку Платон" back={back} source={source} />
                    )}
                />
            </Switch>
        </div>
    );
};

export default PlatonPoints;
